import { useFeatureFlagEnabled as useFeatureFlagEnabledFns } from 'posthog-js/react';

export function useFeatureFlagEnabled(flag: string) {
  const isEnabled = useFeatureFlagEnabledFns(flag);
  return isEnabled || import.meta.env.VITE_IS_DEV === 'true';
}
